import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { TouchableOpacity } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Typography } from 'ucl/components/text/Typography';

import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { spacing } from 'styles/constants';
import { isWeb } from 'utils/environment';

import { Animation } from './animation';
import { Background } from './background';

export const Loader = ({ loading, copy }: { loading: boolean; copy: string }) => {
  const desktop = useIsDesktopBreakpoint();
  const router = useRouter();

  return (
    <SafeAreaView
      style={{
        zIndex: loading ? 9999 : undefined,
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      }}
    >
      <SafeAreaView style={{ position: 'absolute', top: 0, right: spacing.$4, zIndex: 99999 }}>
        <TouchableOpacity onPress={() => router.dismiss()} testID="modal-close-button" hitSlop={15}>
          <Icon variant="cancel" />
        </TouchableOpacity>
      </SafeAreaView>
      <Background desktop={desktop} />
      <Animation />
      <Typography
        variant="copyOne"
        color="white"
        textAlign="center"
        style={{ zIndex: loading ? 9999 : undefined, bottom: isWeb ? undefined : '40%' }}
      >
        {copy}
      </Typography>
    </SafeAreaView>
  );
};
